import React from "react";
import { /* Image, */ Icon } from "semantic-ui-react";
// images
import ConcentratorIcon from "app/_assets/icon/concentrator-icon/ConcentratorIcon.jsx";
import AtasDeviceIcon from "app/_assets/icon/atas-device-icon/AtasDeviceIcon.jsx";
// import ic_flow_alert from 'app/_assets/img/ic_flow_alert.png';
// consts
import { TYPE as DEVICE_TYPE } from "salvus-shared/consts/device";
// utils
import { getBatteryState } from "app/ui/pages/monitor/monitorTableBody/monitorTableRow/deviceIcons/getBatteryState";
// styles
import styles from "./DeviceIcons.module.scss";

function DeviceIcons({ row }) {
  // const bateryState = (batery, type) => {
  //   switch (type) {
  //     case DEVICE_TYPE.CONCENTRATOR: {
  //       const rawCapibility = batery - 3;
  //       let capibility = rawCapibility <= 0 ? 0 : `${parseInt((100 * rawCapibility) / 1.2, 10)}`;
  //       if (capibility > 100) capibility = 100;
  //       return `${capibility}%`;
  //     }
  //     default: {
  //       let capibility = batery > 3.8 ? parseInt(100 - (4.3 - batery) * 160, 10) : batery > 3.7 ? parseInt(20 - (3.8 - batery) * 50, 10) : parseInt(15 - (3.7 - batery) * 30, 10);

  //       if (capibility > 100) capibility = 100;
  //       else if (capibility < 0) capibility = 0;
  //       return `${capibility}%`;
  //     }
  //   }
  // }

  // return (
  // <div className="flex flex-space">
  //   <div>
  //     {row.device.type !== DEVICE_TYPE.CONCENTRATOR && <Image src={ic_atas_device} />}
  //     {row.device.type === DEVICE_TYPE.CONCENTRATOR && <Image src={ic_concentrator} />}
  //   </div>
  //  <div className={`device-batt ${row.alertBattery || row.lowBattery === 2 ? 'red' : row.lowBattery === 1 ? 'yellow' : 'green'}`}>
  //     {row.alertBattery ? (
  //       <Icon name="battery zero" size="large" title={'Bateria crítica.'} />
  //     ) : row.lowBattery === 2 ? (
  //       <Icon name="battery low" size="large" title={'Bateria muito baixa.'} />
  //     ) : row.lowBattery === 1 ? (
  //       <Icon name="battery quarter" size="large" title={'Bateria baixa.'} />
  //     ) : (
  //       <Icon name="battery three quarters" size="large" />
  //     )}
  //     <span> {row.alertBattery ? 'Trocar' : getBatteryState(row.device.battery, row.device.type)} </span>
  //   </div>
  //    <div className={`device-signal ${row.isOffline ? 'red' : row.diffMinutes > 120 ? 'yellow' : 'green'}`}>
  //       <Icon name="wifi" size="large" title={row.isOffline ? 'Dispositivo sem enviar mensagens a mais de 4 horas.' : ''} />
  //         <span>
  //           {' '}
  //           {row.diffMinutes < 60
  //           ? row.diffMinutes + ' min'
  //           : row.diffMinutes > 60 && row.diffMinutes < 1440
  //           ? Math.round(row.diffMinutes / 60) + ' h'
  //           : Math.round(row.diffMinutes / 1440) + ' d'}
  //         </span>
  //     </div>
  // </div>
  // )

  // Constantes para os estados de bateria e sinal
  const BATTERY_LEVEL = {
    CRITICAL: 2,
    LOW: 1,
  };

  const getBatteryStateInfo = (alertBattery, lowBattery) => {
    
    if (alertBattery) {
      return {
        icon: "battery zero",
        title: "Bateria crítica.",
        color: "red",
        text: "Trocar",
      };
    }
    if (lowBattery === BATTERY_LEVEL.LOW) {
      return {
        icon: "battery low",
        title: "Bateria muito baixa.",
        color: "red",
      };
    }
    if (lowBattery === BATTERY_LEVEL.CRITICAL) {
      return {
        icon: "battery quarter",
        title: "Bateria baixa.",
        color: "yellow",
      };
    }
    return {
      icon: "battery three quarters",
      title: "",
      color: "green",
    };
  };

  const getSignalStateInfo = (isOffline, diffMinutes) => {
    if (isOffline) {
      return {
        color: "red",
        title: "Dispositivo sem enviar mensagens a mais de 4 horas.",
      };
    }
    if (diffMinutes > 120) {
      return {
        color: "yellow",
        title: "",
      };
    }
    return {
      color: "green",
      title: "",
    };
  };

  const formatTimeDifference = (diffMinutes) => {
    if (diffMinutes < 60) {
      return `${diffMinutes} min`;
    }
    if (diffMinutes < 1440) {
      return `${Math.round(diffMinutes / 60)} h`;
    }
    return `${Math.round(diffMinutes / 1440)} d`;
  };

  const {
    icon: batteryIcon,
    title: batteryTitle,
    color: batteryColor,
    text: batteryText,
  } = getBatteryStateInfo(row.alertBattery, row.lowBattery);
  const { color: signalColor, title: signalTitle } = getSignalStateInfo(
    row.isOffline,
    row.diffMinutes
  );

  const deviceImage =
    row.device.type === DEVICE_TYPE.CONCENTRATOR ? (
      <ConcentratorIcon fill="#3b3b3bff" size="35" />
    ) : (
      <AtasDeviceIcon fill="#3b3b3bff" size="35" />
    );

  return (
    <div className={styles.deviceRow}>
      <div className={styles.deviceRow__icon}>{deviceImage}</div>
      <div
        className={`${styles.deviceRow__signal} ${
          styles[`deviceRow__signal--${signalColor}`]
        }`}
      >
        <Icon name="wifi" size="large" title={signalTitle} />
        <span className={styles.deviceRow__signalText}>
          {" "}
          {formatTimeDifference(row.diffMinutes)}{" "}
        </span>
      </div>
      <div
        className={`${styles.deviceRow__battery} ${
          styles[`deviceRow__battery--${batteryColor}`]
        }`}
      >
        <Icon name={batteryIcon} size="large" title={batteryTitle} />
        <span className={styles.deviceRow__iconText}>
          {batteryText || getBatteryState(row.device.battery, row.device.type)}
        </span>
      </div>


    </div>
  );
}

export default DeviceIcons;
